<script setup lang="ts">
import MainLayout from '../components/layouts/MainLayout.vue'
import OrderListSelection from '../components/orders/OrderListSelection.vue'
</script>

<template>
  <MainLayout>
    <OrderListSelection />
  </MainLayout>
</template>
